export const projectsData = [
    {
        title: 'Mini E-Commerce Web Application',
        projectCategory: [
            'Fullstack - MERN application'
        ],
        technologies: [
            'Mongo DB', 'Express Js', 'React Js', 'Node Js', 'Typescript', 'TailwindCSS', 'Redux', 'Axios'
        ],
        projectDesc: "A full-featured e-commerce platform with product listings, shopping cart, user authentication, and secure checkout built with the MERN stack.",
        projectLink: "https://ecommerce-client-rosy.vercel.app",
        projStatus: true
    },
    {
        title: 'Asoebi By Nandari',
        projectCategory: [
            'Fullstack - MERN application'
        ],
        technologies: [
            'Mongo DB', 'Express Js', 'React Js', 'Node Js', 'Typescript', 'TailwindCSS', 'Redux', 'Axios'
        ],
        projectDesc: "An elegant marketplace for African fashion and asoebi styles, enabling users to browse, select, and order traditional attire with a seamless experience.",
        projectLink: "https://www.nandari.com",
        projStatus: true
    },
    {
        title: 'Panthera',
        projectCategory: [
            'Single page frontend web application - MERN application'
        ],
        technologies: [
            'Mongo DB', 'Express Js', 'React Js', 'Node Js', 'Typescript', 'TailwindCSS', 'Redux', 'Axios'
        ],
        projectDesc: "A sleek single-page brand showcase for Panthera, featuring modern design, smooth animations, and responsive layouts across all devices.",
        projectLink: "https://www.pantheraicl.com",
        projStatus: true
    }
];
